export default __webpack_public_path__ + "assets/images/4a3db7f0584d24242a497466ba061879.webp";